<template>
  <div class="dashboard container">
    <div v-if="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-grow m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div class="pt-5" v-else-if="!loading && error">
      <div class="text-center error m-5 p-5">
        <span>Произошла ошибка, попробуйте позже!</span>
      </div>
    </div>

    <!--Subscriber dashboard-->
    <div v-else-if="userData.role === 'subscriber'">

      <div v-if="!subscriptionList">
        <div class="text-center error m-5 p-5">
          <span>У вас нет подписок, пожалуйста, обратитесь в службу поддержки.</span>
        </div>
      </div>

      <div v-else>

        <div class="row py-5 text-center border-bottom">
          <div class="col">
            <h5 class="font-weight-bold">
              Договор: №{{ userData.username }}, {{ userData.last_name }}
              {{ userData.first_name }} {{ userData.middle_name }}
            </h5>
          </div>
          <div class="col">
            <h5 class="font-weight-bold">
              Баланс: {{ userData.balance }}&#8381;
            </h5>
          </div>
        </div>

        <div class="row py-5 text-center border-bottom">
          <div class="col">
            <font-awesome-icon @click="refill" :icon="['fas', 'cash-register']" size="4x" />
            <div class="pt-3 d-none d-sm-block">
              <h5 class="font-weight-bold">Финансовые операции</h5>
            </div>
          </div>
          <div class="col">
            <font-awesome-icon @click="help" :icon="['fas', 'question-circle']" size="4x" />
            <div class="pt-3 d-none d-sm-block">
              <h5 class="font-weight-bold">Служба поддержки</h5>
            </div>
          </div>
        </div>


        <div class="row py-5" v-if="refillForm">
          <div class="col-12 col-lg-6">
            <v-payment-create-form :phone="userData.contact_phone" />
          </div>
          <div class="col-12 col-lg-6 pl-lg-5 pt-5 pt-lg-0">
            <div class="pl-3 border-left">
              <h5>Пополнение баланса:</h5>
              <ul v-for="p in paymentList" :key="p.id">
                <li>
                  {{ fixDate(p.created_at) }} пополнение баланса: {{ p.amount }} &#8381;
                </li>
              </ul>
              <div v-for="subscription in subscriptionList" :key="subscription.id">
                <h6 v-if="subscription.sim_card">
                  Подписка: {{ subscription.tariff.name }}
                <span v-if="subscription.is_active" class="badge badge-success">
                  Активна
                </span>
                <span v-else-if="!subscription.is_active" class="badge badge-danger">
                  Не активна
                </span>
                </h6>
                <h6 v-else>
                  Подписка: {{ subscription.tariff.name }}
                  <span class="badge badge-secondary">Архив</span>
                </h6>
                <ul v-for="sp in subscription.subscription_payment" :key="sp.id">
                  <li>
                    {{ fixDate(sp.created_at) }} оплата подписки: {{ sp.amount }} &#8381;
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
        <div v-else-if="helpForm" class="py-5">
          <v-help-form  @close="helpForm=false"/>
        </div>
        <div v-else class="py-5">
          <h5 class="pb-3">Ваши подписки:</h5>
          <div v-for="s in subscriptionList" :key="s.id">
            <div class="row border py-3 my-3">
              <div class="col-12 col-lg-4 pb-2">Тариф: {{ s.tariff.name }}</div>
              <div class="col-12 col-lg-4 pb-2">
                День платежа: до {{ s.payment_day }}-го числа
              </div>
              <div class="col-12 col-lg-4 text-center">
                <span v-if="!s.sim_card" class="badge badge-secondary">Архив</span>
                <span v-if="s.is_active === null" class="badge badge-warning">
                  Приостановлена</span>
                <span v-else-if="s.is_active === true" class="badge badge-success">
                  Активна</span>
                <span v-else-if="s.sim_card && s.is_active === false" class="badge badge-danger">
                  Неактивна</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!--Administrator dashboard-->
    <div v-else-if="userData.role === 'administrator' || userData.role === 'dealer'
    || userData.role === 'employee'">
      <div v-if="statistic.pending_payments" class="alert alert-danger" role="alert">
        <div v-if="userData.role === 'administrator'">
          Неподтвержденные платежи дилеру: {{ statistic.pending_payments}}
        </div>
        <div v-else-if="userData.role === 'dealer'">
          Платежи в ожидании оплаты: {{ statistic.pending_payments}}
        </div>
      </div>
      <div v-if="statistic.pending_to_unblock" class="alert alert-danger" role="alert">
        <div v-if="userData.role === 'administrator'">
          Необходимо разблокировать у оператора: {{ statistic.pending_to_unblock}}
        </div>
      </div>
      <div><h4>Подписки, SIM карты и балансы</h4></div>
      <div class="row text-center">
        <div v-if="userData.role !== 'employee'" class="col-3 p-3 border">
          <div><h6>Активных: </h6></div>
          <div><h5 class="font-weight-bold">{{ statistic.active_subscriptions }} шт</h5></div>
        </div>
        <div v-else class="col-3 p-3 border">
          <div><h6>Alerted SIM: </h6></div>
          <div><h5 class="font-weight-bold">{{ statistic.alerted_sim }} шт</h5></div>
        </div>
        <div class="col-3 p-3 border">
          <div><h6>Неактивных: </h6></div>
          <div><h5 class="font-weight-bold">{{ statistic.inactive_subscriptions }} шт</h5></div>
        </div>
        <div class="col-3 p-3 border">
          <div><h6>Новых SIM: </h6></div>
          <div><h5 class="font-weight-bold">{{ statistic.new_sim }} шт</h5></div>
        </div>
        <div v-if="userData.role === 'administrator'" class="col-3 p-3 border">
          <div><h6>На балансах: </h6></div>
          <div><h5 class="font-weight-bold">
            {{ statistic.total_subscribers_balance }} &#8381;</h5></div>
        </div>
        <div v-else-if="userData.role === 'dealer'" class="col-3 p-3 border">
          <div><h6>Ваш баланс: </h6></div>
          <div><h5 class="font-weight-bold">
            {{ userData.balance }} &#8381;</h5></div>
        </div>
        <div v-else class="col-3 p-3 border">
          <div><h6>Alerted подписки: </h6></div>
          <div><h5 class="font-weight-bold">{{ statistic.alerted_subscriptions }} шт</h5></div>
        </div>
      </div>

      <div  v-if="userData.role !== 'dealer'" class="pt-3" >
        <div><h4>Балансы на шлюзах и предстоящие исходящие платежи</h4></div>
        <div class="row text-center">
          <div class="col-lg-3 p-3 border"
               v-bind:class="statistic.balances.provider_payment >
               (statistic.balances.expected_payment + statistic.balances.late_payment)
               ? 'balance_info' : 'balance_warning'">
            <div><h6>Баланс Сервиса: </h6></div>
            <div>
              <h5 class="font-weight-bold">
              {{ statistic.balances.provider_payment }} &#8381;
              </h5>
            </div>
          </div>
          <div class="col-lg-3 p-3 border"
               v-bind:class="statistic.balances.sms_gate > 100
               ? 'balance_info' : 'balance_warning'">
            <div><h6>Баланс SMS: </h6></div>
            <div>
              <h5 class="font-weight-bold">
                {{ statistic.balances.sms_gate }} &#8381;
              </h5>
            </div>
          </div>
          <div class="col-lg-3 p-3 border">
            <div><h6>Оплат на завтра: </h6></div>
            <div>
              <h5 class="font-weight-bold">
                 {{ statistic.balances.expected_payment }} &#8381;
              </h5>
            </div>
          </div>
          <div class="col-lg-3 p-3 border">
            <div><h6>Просрочено оплат: </h6></div>
            <div>
              <h5 class="font-weight-bold">
                 {{ statistic.balances.late_payment }} &#8381;
              </h5>
            </div>
          </div>
        </div>
      </div>

      <div class="pt-3" v-if="userData.role === 'administrator' || userData.role === 'dealer'">
        <div><h4>Финансы и комиссии (текущий месяц)</h4></div>
        <div class="row text-center">
          <div class="col-4 p-3 border">
            <div><h6>Подписок: </h6></div>
            <div>
              <h5 class="font-weight-bold">
              {{ statistic.activation }} шт
              </h5>
            </div>
          </div>
          <div class="col-4 p-3 border">
            <div><h6>Списаний: </h6></div>
            <div>
              <h5 class="font-weight-bold">
                {{ statistic.subscription_payments }} &#8381;
              </h5>
            </div>
          </div>
          <div v-if="userData.role === 'administrator'" class="col-4 p-3 border">
            <div><h6>Пополнений: </h6></div>
            <div>
              <h5 class="font-weight-bold">
                {{ statistic.payments }} &#8381;
              </h5>
            </div>
          </div>
          <div v-else class="col-4 px-3">
            <div class="form-group">
              <input v-mask="['#####', '#####']" class="form-control"
                        required id="amount" v-model="amount"
                        @focusin="InputFocusIn('amount')" @focusout="InputFocusOut('amount')"/>
              <label for="amount">Введите сумму(min 500&#8381;)</label>
            </div>
            <button class="btn-primary" @click="newDealerPayment()">Запросить вывод</button>
          </div>
        </div>
      </div>

      <div class="pt-5 line-chart" v-if="userData.role === 'dealer'
      || userData.role === 'administrator'">
        <v-line-chart :chart-data="datacollection" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import VPaymentCreateForm from '../../components/forms/v-payment-create-form.vue';
import VLineChart from '../../components/charts/v-line-chart.vue';
import VHelpForm from '../../components/forms/v-help-form.vue';

export default {
  name: 'dashboard',
  components: { VHelpForm, VLineChart, VPaymentCreateForm },
  data() {
    return {
      loading: true,
      refillForm: false,
      helpForm: false,
      datacollection: {},
      amount: '',
    };
  },
  computed: {
    ...mapState('user', ['userData', 'error']),
    ...mapState('statistic', ['statistic', 'error']),
    ...mapState('subscription', ['subscriptionList', 'error']),
    ...mapState('payment', ['paymentList', 'crateDealerPaymentError', 'createDealerPaymentError']),
  },
  methods: {
    ...mapActions('subscription', ['getSubscriptionList']),
    ...mapActions('statistic', ['getStatistic']),
    ...mapActions('payment', ['getPaymentList', 'createDealerPayment']),
    ...mapActions('user', ['getUserDetail']),
    help() {
      this.refillForm = false;
      this.helpForm = !this.helpForm;
    },
    refill() {
      this.helpForm = false;
      this.refillForm = !this.refillForm;
    },
    newDealerPayment() {
      const paymentData = { amount: this.amount };
      this.createDealerPayment(paymentData)
        .then(() => {
          if (!this.createDealerPaymentError) {
            this.$notify({
              group: 'message',
              title: 'New message:',
              type: 'success',
              text: 'Ваш заказ на выплату успешно принят!',
            });
            this.getUserDetail();
            this.getStatistic();
          } else {
            this.$notify({
              group: 'message',
              title: 'Ошибка:',
              type: 'error',
              text: this.createDealerPaymentError,
            });
          }
        });
    },
    fillData() {
      if (this.userData.role === 'administrator') {
        this.datacollection = {
          labels: this.statistic.chart_data.labels,
          datasets: [
            {
              label: 'Комиссия дилера, тыс',
              backgroundColor: '#9c2622',
              data: this.statistic.chart_data.dealer_fee,
            }, {
              label: 'Комиссия сервиса, тыс',
              backgroundColor: '#f1b636',
              data: this.statistic.chart_data.service_fee,
            }, {
              label: 'Списания, тыс',
              backgroundColor: '#0a8121',
              data: this.statistic.chart_data.subscription_payments,
            }, {
              label: 'Пополнения, тыс',
              backgroundColor: '#005d69',
              data: this.statistic.chart_data.payments,
            },
          ],
        };
      }
      if (this.userData.role === 'dealer') {
        this.datacollection = {
          labels: this.statistic.chart_data.labels,
          datasets: [
            {
              label: 'Комиссия, тыс',
              backgroundColor: '#005d69',
              data: this.statistic.chart_data.dealer_fee,
            },
          ],
        };
      }
    },
  },
  mounted() {
    if (this.userData.role === 'administrator' || this.userData.role === 'dealer'
      || this.userData.role === 'employee') {
      this.getStatistic()
        .finally(() => {
          this.fillData();
          this.loading = false;
        });
    }
    if (this.userData.role === 'subscriber') {
      this.getPaymentList('?get_all=true');
      this.getSubscriptionList('?with_deleted=true&get_all=true')
        .finally(() => {
          this.loading = false;
        });
    }
  },
};
</script>
